"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var SavedBlockFilterViewStore_1 = require("SavedBlock/SavedBlockFilterViewStore");
var SavedBlockFilterPanel_1 = __importDefault(require("SavedBlock/SavedBlockFilterPanel/SavedBlockFilterPanel"));
var BASE_CLASS_NAME = "saved-block-filter";
var SavedBlockFilterSelector = (function (_super) {
    __extends(SavedBlockFilterSelector, _super);
    function SavedBlockFilterSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleBlockType = function (type) {
            var _a = _this.props, savedBlockViewStore = _a.savedBlockViewStore, telemetryContext = _a.telemetryContext;
            _this.savedBlockFilterViewStore.toggleBlockType(type);
            if (savedBlockViewStore.selectedBlockTypeFilterList && savedBlockViewStore.selectedBlockTypeFilterList.length > 0) {
                _this.props.telemetry.trackOnly("Saved Block Library Filtered", {
                    saved_block_origin: telemetryContext,
                    saved_block_library_filtered_by: savedBlockViewStore.selectedBlockTypeFilterList.join(", "),
                }, {});
            }
        };
        _this.renderPanel = function () {
            return (react_1.default.createElement(SavedBlockFilterPanel_1.default, { savedBlockFilterViewStore: _this.savedBlockFilterViewStore, onToggleBlockType: _this.toggleBlockType }));
        };
        _this.renderButton = function (buttonProps) {
            if (_this.props.compactButton) {
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ size: kaleidoscope_1.ButtonSize.Medium, type: kaleidoscope_1.ButtonType.Tertiary, icon: react_1.default.createElement(icons_1.Filter, null) }, buttonProps)),
                    _this.savedBlockFilterViewStore.numFilters > 0 && (react_1.default.createElement("span", { className: "".concat(BASE_CLASS_NAME, "__filter-count") },
                        " ",
                        _this.savedBlockFilterViewStore.numFilters))));
            }
            else {
                return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small, className: "".concat(BASE_CLASS_NAME, "__button") }, buttonProps),
                    react_1.default.createElement(icons_1.Filter, null),
                    _this.savedBlockFilterViewStore.filterLabel));
            }
        };
        _this.savedBlockFilterViewStore = new SavedBlockFilterViewStore_1.SavedBlockFilterViewStore(_this.props.savedBlockViewStore);
        return _this;
    }
    SavedBlockFilterSelector.prototype.render = function () {
        return (react_1.default.createElement("div", { className: BASE_CLASS_NAME },
            react_1.default.createElement(kaleidoscope_1.Popover, { onChange: this.savedBlockFilterViewStore.handlePopoverChange, className: "".concat(BASE_CLASS_NAME, "__popover"), button: this.renderButton }, this.renderPanel())));
    };
    SavedBlockFilterSelector = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SavedBlockFilterSelector);
    return SavedBlockFilterSelector;
}(react_1.default.Component));
exports.default = SavedBlockFilterSelector;
